import { Injectable, inject } from '@angular/core';
import { TableCol, TableService } from 'ets-fe-ng-sdk';
import { MenuAccessService } from 'projects/shared/src/lib/permissions/menu-access.service';
import { isMenuEditAction } from 'projects/shared/src/lib/permissions/menu-action';

@Injectable({ providedIn: 'root' })
export class MenuTablePermissionsService {
  private readonly access = inject(MenuAccessService);
  private readonly tables = inject(TableService);

  initialize(): void {
    const format = this.tables.globalColumnsFormatter;
    this.tables.globalColumnsFormatter = <T>(columns: TableCol<T>[]) => this.protectColumns(format(columns));
  }

  protectColumns<T>(columns: TableCol<T>[]): TableCol<T>[] {
    const canEdit = this.access.canEdit();
    return columns.map((column) => {
      const edits =
        column.type === 'editable' ||
        isMenuEditAction(column) ||
        (column.btn && isMenuEditAction(column.btn));
      return {
        ...column,
        ignore: column.ignore || (!!edits && !canEdit && column.type !== 'editable'),
        disabled: column.disabled || (!!edits && !canEdit && column.type !== 'editable'),
        type: column.type === 'editable' && !canEdit ? 'text' : column.type,
        action:
          edits && column.action
            ? (...args: Parameters<NonNullable<TableCol<T>['action']>>) => {
                if (this.access.canEdit()) return column.action?.(...args);
              }
            : column.action,
        btn: column.btn
          ? {
              ...column.btn,
              action:
                edits && column.btn.action
                  ? (...args: Parameters<NonNullable<typeof column.btn.action>>) => {
                      if (this.access.canEdit()) return column.btn?.action?.(...args);
                    }
                  : column.btn.action,
            }
          : column.btn,
        buttons: column.buttons
          ?.filter((button) => canEdit || !isMenuEditAction(button))
          .map((button) => ({
            ...button,
            action:
              isMenuEditAction(button) && button.action
                ? (...args: Parameters<NonNullable<typeof button.action>>) => {
                    if (this.access.canEdit()) return button.action?.(...args);
                  }
                : button.action,
          })),
      };
    });
  }
}
